import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MainService } from 'src/app/services/main-service.service';
import { environment } from 'src/environments/environment';
declare var Stripe: any;

@Component({
	selector: 'app-gpay',
	templateUrl: './gpay.component.html',
	styleUrls: ['./gpay.component.scss']
})
export class GpayComponent implements OnInit {
	buttonColor = "black";
	buttonType = "pay";
	isCustomSize = false;
	buttonWidth = 260;
	buttonHeight = 60;
	isTop = window === window.top;
	//google pay integration
	paymentDataRequest: any;
	paymentsClient: any;
	stripe: any;
	current_env: any = environment.production != true ? "TEST" : "PRODUCTION";
	@Input('final_amount') final_amount: any;
	@Input('customClass') customClass: any = '';
	@Output() confirmPayment = new EventEmitter<{ token: string, payment_source_type: number, wallet: number }>();
	paymentRequest = {
		apiVersion: 2,
		apiVersionMinor: 0,
		allowedPaymentMethods: [
			{
				type: "CARD",
				parameters: {
					allowedAuthMethods: ["PAN_ONLY", "CRYPTOGRAM_3DS"],
					allowedCardNetworks: ["AMEX", "DISCOVER", "INTERAC", "JCB", "MASTERCARD", "VISA"]
				}
				,
				tokenizationSpecification: {
					type: 'PAYMENT_GATEWAY',
					parameters: {
						"gateway": "stripe",
						"stripe:version": "2019-12-03",
						"stripe:publishableKey": environment.stripe_pk
					}
				}
			}
		],
		merchantInfo: {
			merchantId: "BCR2DN4TQSCYVXZJ",
			merchantName: "Credee LLC"
		},
		transactionInfo: {
			totalPriceStatus: "FINAL",
			totalPriceLabel: "Total",
			totalPrice: "10",
			currencyCode: "USD",
			countryCode: "US"
		}
	};

	constructor(public httpClient: HttpClient, public mainService: MainService) {
	}

	ngOnInit() {
	}

	onLoadPaymentData($event) {
		console.log("event", $event);
		if ($event && $event.detail && $event.detail.paymentMethodData && $event.detail.paymentMethodData.tokenizationData && $event.detail.paymentMethodData.tokenizationData.token) {
			console.log("111");
			let paymentToken = $event.detail.paymentMethodData.tokenizationData.token;
			this.confirmPayment.emit({ token: JSON.parse(paymentToken).id, payment_source_type: 4, wallet: 2 });
		} else {
			console.log("222");
			this.stripe = Stripe(this.mainService.stripe_pk);
			this.paymentRequest.transactionInfo.totalPrice = (this.final_amount || 1).toString();
			this.paymentRequest.allowedPaymentMethods[0].tokenizationSpecification.parameters['stripe:publishableKey'] = this.mainService.stripe_pk;
			this.paymentsClient = new google.payments.api.PaymentsClient({ environment: this.current_env });
			this.paymentsClient.loadPaymentData(this.paymentRequest).then((paymentData) => {
				console.log("paymentData--", paymentData);
				let paymentToken = paymentData.paymentMethodData.tokenizationData.token;
				this.confirmPayment.emit({ token: JSON.parse(paymentToken).id, payment_source_type: 4, wallet: 2 });
			}).catch(function (err) {
				// show error in developer console for debugging
				console.error(err);
			});
		}
	}

	ngOnDestroy() {
		//this.mainService.stripeKeySubject.unsubscribe();
		 if (this.paymentsClient) {
			this.paymentsClient = null;
			}
			this.paymentRequest = null;
			this.stripe = null;
  		}
}
